<template>
  <div>
    <h3>Undertakings{{type === 'search' ? ' Search' : ''}}</h3>
    <div class="container" v-if="type === 'search'">
        <div>
        <tabs nav-style="tabs" v-model="activeTabIndex">
            <tab header="Undertaking">
                <form v-if="type ==='search'" @submit.prevent="loadData" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-sm-2">
                            <label for="searchDbNumber">DB Number</label>
                        </div>
                        <div class="col-sm-3">
                            <input class="form-control" type="text" name="searchDbNumber" v-model="searchDto.dbNumber">
                        </div>
                        <div class="col-sm-2 col-sm-offset-1">
                            <label for="searchName">Name</label>
                        </div>
                        <div class="col-sm-4">
                            <input class="form-control" type="text" name="searchName" v-model="searchDto.name">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <label for="searchAgencyNo">Agency Number</label>
                        </div>
                        <div class="col-md-3">
                            <input class="form-control" type="text" name="searchAgencyNo" v-model="searchDto.agencyNumber">
                        </div>
                        <div class="col-sm-2 col-sm-offset-1">
                            <label for="searchTimeframe">Review Timeframe</label>
                        </div>
                        <div class="col-sm-4">
                            <select class="form-control" name="searchTimeframe" v-model="searchDto.reviewTimeframeId">
                                <option value="">Select Review Timeframe</option>
                                <option v-for="timeframe in reviewTimeframeList" :value="timeframe.id" :key="timeframe.id">{{timeframe.description}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-sm-2">
                            <label for="searchStatus">Status</label>
                        </div>
                        <div class="col-sm-3">
                            <select class="form-control" name="workflowStatusId" v-model="searchDto.workflowStatusId">
                                <option value="">Select Workflow Status</option>
                                <option v-for="status in workflowList" :value="status.workflowStatusId" :key="status.workflowStatusId">{{status.description}}</option>
                            </select>
                        </div>
                        <div class="col-sm-2 col-sm-offset-1">
                            <label for="searchEffect">Finding of Effect</label>
                        </div>
                        <div class="col-sm-4">
                            <select class="form-control" name="searchEffect" v-model="searchDto.effectId">
                                <option value="">Select Finding of Effect</option>
                                <option v-for="effect in effectList" :value="effect.effectId" :key="effect.effectId">{{effect.description}}</option>
                            </select>
                        </div>
                        
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary" type="submit" name="button" v-on:click="loadData">Search</button>
                        </div>
                    </div>
                </form>
            </tab>
            <tab header="Undertaking By TRS">
                <form v-if="type ==='search'" @submit.prevent="loadTRSData" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <plssComponent ref="plssComponent" :showTitle="false" :showSaveBtn="false" v-on:savePlss="loadTRSData" :id="'Ut'" :key="utPlssCompKey"></plssComponent>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary" type="submit" name="btnTrsSearch" v-on:click="validateTrs">Search</button>
                        </div>
                    </div>
                </form>
            </tab>
        </tabs>
        </div>
    </div>
    <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
            <div class="pull-right">
                <router-link v-if="type ==='search'" to="/Undertaking" tag="button" class="btn btn-primary btn-block">Add New</router-link>
            </div>
            <loader v-if="loading"/>
            <div class="col-md-2 form-group" v-if="isUserRc && type ==='todo'">
                <div class="pull-right">
                    <input class="form-check-input" type="checkbox" v-model="searchDto.showAll" style="width: 20px; height: 20px;">
                </div>
                <div class="pull-right">
                    <label class="form-check-label" for="showAll">Show All&nbsp;</label>
                </div>
            </div>
            <div>
                <v-client-table :data="utGridSpec.tableData" :columns="gridSpecColumns" :options="utGridSpec.options">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.undertakingId)"></a> -->
                        <router-link :to="{ path: '/Undertaking/' + props.row.undertakingId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                    </div>
                </template>
                </v-client-table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loggingService from '../services/util/loggingService'
import undertakingService from '../services/undertakingService'
import workflowService from '../services/workflowService'
import evaluationService from '@/services/siteForm/evaluationService'
import lookupService from '@/services/lookup/lookupService'
import roleService from '../services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'
import loader from '../components/Loader.vue'
import plssComponent from '@/components/PlssComponent'
import { tab, tabs } from 'vue-strap'

export default {
    components: {
        loader,
        tab,
        tabs,
        plssComponent
    },
    data: function () {
        return {
            isDebug: false,
            loading: true,
            activeTabIndex: 0,
            reviewTimeframeList: [],
            effectList: evaluationService.UndertakingEffectList,
            workflowList: [],
            trsSearchDto: {

            },
            searchDto: {
                name: '',
                dbNumber: '',
                agencyNumber: '',
                reviewTimeframeId: '',
                workflowStatusId: '',
                effectId: '',
                showAll: false
            },
            plssSearchList: [],
            utGridSpec: {
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate', 'workflowStatusDate'],
                    headings: {
                        name: 'Name',
                        dbNumber: 'DB Number',
                        createdDate: 'Created Date',
                        workflowStatusDescription: 'Status',
                        workflowStatusDate: 'Status Date',
                        effect: 'Finding of Effect',
                        reviewTimeframe: 'Review Timeframe',
                        agencyDescription: 'Agency',
                        agencyUndertakingNo: 'Agency No',
                        assignedAgent: 'Assigned Agent'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'workflowStatusDate'
                    }
                }
            },
            utPlssCompKey: 0
        }
    },
    props: {
        type: {
            type: String,
            default: 'search'
        },
        isUserRc: { default: false }
    },
    watch: {
        'searchDto.showAll': function () {
            this.loadData()
        }
    },
    computed: {
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isShpo: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
        },
        gridSpecColumns: function () {
            var columns = ['edit', 'workflowStatusDescription', 'workflowStatusDate', 'dbNumber', 'name', 'agencyDescription', 'agencyUndertakingNo', 'effect', 'reviewTimeframe', 'createdDate']
            if (this.type === 'todo') {
                columns.push('assignedAgent')
            }
            return columns
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Undertakings', 'mounted')
        this.loadData()
        this.loadWorkflow()
        this.loadReviewTimeframeList()
    },
    methods: {
        throwException () {
            undertakingService.throwException(this.$http)
        },
        loadData () {
            if (this.type === 'search') {
                loggingService.log(this.isDebug, 'Undertakings', 'loadData.search')
                undertakingService.search(this.$http, this.searchDto).then(response => {
                    this.utGridSpec.tableData = response.data
                    this.loading = false
                })
            } else if (this.type === 'todo') {
                loggingService.log(this.isDebug, 'Undertakings', 'loadData.todo')
                undertakingService.todo(this.$http, this.searchDto).then(response => {
                    this.utGridSpec.tableData = response.data
                    this.loading = false
                })
            } else {
                loggingService.log(this.isDebug, 'Undertakings', 'loadData - unknown type: ' + this.type)
            }
        },
        validateTrs () {
            if (this.type === 'search') {
                this.$refs.plssComponent.savePlss()
            }
        },
        loadTRSData () {
            var trsDto = this.$refs.plssComponent.plssData
            console.log(trsDto)
            if (trsDto !== null) {
                this.trsSearchDto = trsDto
                var trsDtoList = []
                if (trsDto.Sections.length > 0) {
                    trsDto.Sections.forEach(section => {
                        trsDtoList.push(
                            {
                                Township: trsDto.Township,
                                TownshipDirection: trsDto.TownshipDirection,
                                Range: trsDto.Range,
                                RangeDirection: trsDto.RangeDirection,
                                Section: section,
                                MeridianId: trsDto.MeridianId
                            }
                        )
                    })
                } else {
                    trsDto.section = 0
                    trsDtoList.push(trsDto)
                }
                this.plssSearchList = trsDtoList

                undertakingService.searchByTrs(this.$http, this.plssSearchList).then(response => {
                    this.utGridSpec.tableData = response.data
                    this.loading = false
                })
            }
        },
        loadWorkflow () {
            workflowService.listByWorkflowId(this.$http, workflowService.WorkflowEnum.Undertaking).then(result => {
                this.workflowList = result.data.reverse()
            })
        },
        loadReviewTimeframeList () {
            return lookupService.listLookup(this.$http, 'ReviewTimeframe').then(response => {
                this.reviewTimeframeList = response.data
                return response
            })
        },
        editRow (id) {
            loggingService.log(this.isDebug, 'Undertaking', 'editRow, id: ' + id)

            this.$router.push('/Undertaking/' + id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// Undertakings.vue?858f1384